module.exports = __webpack_public_path__ + "static/media/team1.80aeb6d6.png";